import { useCallback, useState } from "react"
import { useSetState } from "@/reactUse"
import { getBoard, updateBoard } from "@/api/board"
import { createModel } from "hox"
import { remove, forIn } from "lodash"

type State = {
  id?: string
  type?: string
  source?: number
  userName?: string
  panel?: { value: any }
  create_at?: number
  name?: string
  lookUsers?: string[]
}

function usePanelModel() {
  const [board, setBoard] = useState({ value: null })
  const [state, set] = useSetState<State>({ panel: { value: null } })
  const acquirePanelData = useCallback(
    async (id: string | number) => {
      try {
        const result = await getBoard(id)
        const {
          id: bId,
          type,
          source,
          userName,
          create_at,
          name,
          lookUsers = [],
        } = result.board as any
        const data = result.data
        let state = {
          panel: { value: data },
          id: bId,
          type,
          source,
          userName,
          create_at,
          name,
          board: data,
          lookUsers,
        }
        set(state)
        setBoard({ value: data })
      } catch (error) {}
    },
    [set]
  )

  const setPanelData = useCallback(
    data => {
      set({ panel: { value: data } })
      setBoard(data)
    },
    [set]
  )

  const deletePanelChart = useCallback(
    async (id: string | number) => {
      let { charts, layouts } = state.panel.value

      remove(charts, function(chart: any) {
        return chart.id === id
      })

      forIn(layouts, function(value) {
        remove(value, function(layout: any) {
          return layout.i === id
        })
      })

      let value = { charts, layouts }

      await updateBoard(state.id, JSON.stringify(value))
      setPanelData(value)
    },
    [state.id, setPanelData, state.panel]
  )

  return {
    ...state,
    board,
    acquirePanelData,
    setPanelData,
    deletePanelChart,
  }
}

export default createModel(usePanelModel)
